<template>
    <div class="vm-nav-tab-item-group">
        <template v-if="type == 'setting'">
            <nav-tab-item
                :text="$t('c.NavTabItemGroup.text1')"
                :class="{ on: name == 'settingAccount' }"
                name="settingAccount"
            ></nav-tab-item>
            <template v-if="is_creator">
                <nav-tab-item
                    :text="$t('c.NavTabItemGroup.text2')"
                    :class="{ on: name == 'settingCreator' }"
                    name="settingCreator"
                ></nav-tab-item>
                <nav-tab-item
                    :text="$t('c.NavTabItemGroup.text3')"
                    :class="{ on: name == 'settingPlan' }"
                    name="settingPlan"
                ></nav-tab-item>
                <nav-tab-item
                    v-if="!is_applying_apple && !is_applying_google"
                    :text="$t('c.NavTabItemGroup.text4')"
                    :class="{ on: name == 'settingShop' }"
                    name="settingShop"
                ></nav-tab-item>
                <nav-tab-item
                    :text="$t('c.NavTabItemGroup.text5')"
                    :class="{ on: name == 'settingGoal' }"
                    name="settingGoal"
                ></nav-tab-item>
                <!-- <nav-tab-item
                    text="提现方式"
                    :class="{ on: name == 'settingPayment' }"
                    name="settingPayment"
                ></nav-tab-item> -->
                <nav-tab-item
                    :text="$t('c.NavTabItemGroup.text6')"
                    :class="{ on: name == 'settingGroup' }"
                    name="settingGroup"
                ></nav-tab-item>
            </template>
        </template>
        <template v-if="type == 'dashboard'">
            <nav-tab-item
                v-if="is_creator"
                :text="$t('c.NavTabItemGroup.text7')"
                :class="{ on: name == 'stats' }"
                name="dashboardStats"
            ></nav-tab-item>
            <nav-tab-item
                v-if="is_creator"
                :text="$t('c.NavTabItemGroup.text8')"
                :class="{ on: name == 'sponsored-bill' }"
                name="dashboardSponsored-bill"
            ></nav-tab-item>
            <nav-tab-item
                v-if="is_creator"
                :text="$t('c.NavTabItemGroup.text9')"
                :class="{ on: name == 'income' }"
                name="dashboardIncome"
            ></nav-tab-item>
            <nav-tab-item
                :text="$t('c.NavTabItemGroup.text10')"
                :class="{ on: name == 'sponsoring' }"
                name="dashboardSponsoring"
            ></nav-tab-item>
            <nav-tab-item
                :text="$t('c.NavTabItemGroup.text11')"
                :class="{ on: name == 'mark' }"
                name="dashboardMark"
            ></nav-tab-item>
            <!-- <nav-tab-item
                v-if="session_user && session_user.has_purchased"
                text="我购买的"
                :class="{ on: name == 'purchased' }"
                name="dashboardPurchased"
            ></nav-tab-item> -->
            <nav-tab-item
                v-if="session_user"
                :text="$t('c.NavTabItemGroup.text12')"
                :class="{ on: name == 'order' }"
                class="type-1"
                name="dashboardOrder"
            ></nav-tab-item>
        </template>
        <!--<nav-tab-item v-if="is_creator" text="隐私设置" :class="{on: name == 'editPrivacy'}" name="editPrivacy"></nav-tab-item>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "nav-tab-item-group",
    props: {
        name: {
            type: String,
            default() {
                return "";
            },
        },
        type: {
            type: String,
            default() {
                return "setting";
            },
        },
    },
    computed: {
        ...mapState("app", ["session_user", "user_status",'is_applying_apple', 'is_applying_google']),
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="stylus" scoped>
.vm-nav-tab-item-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .vm-nav-tab-item {
        margin-left: px2rem(32);

        &:first-child {
            margin-left: 0;
        }
    }

    @media (max-width: $width-mobile) {
        .vm-nav-tab-item {
            margin-bottom: px2rem(24);
            width: 33%;
            height: px2rem(32);
            margin-left: 0;
        }
    }
}
</style>
